import { FormControl, InputLabel, Select, MenuItem, Tooltip } from "@mui/material";
import { ENERGY_MEASUREMENT_OPTIONS, QUESTION_ENERGY_MEASUREMENT_KEY } from "../../../../constants/wizardConstants";

export const EnergyMeasureQuestion = ({ energyMeasurment, systemFluid, answerQuestion }) => {
    const toolTipText = "Inkompatibel med angiven systemvätska";

    /**
     * 
     * @param {{ value: string, label: string, fluidNonCompatible?: string[]}} option 
     */
    const disableChoice = (option) => {
        if (option?.fluidNonCompatible != null) {
            return option.fluidNonCompatible.includes(systemFluid);
        }

        return false;
    }

    return (
        <FormControl size="small">
            <InputLabel>Energimätning</InputLabel>
            <Select
                sx={{ width: '180px', height: '30px', background: 'white' }}
                size="small"
                value={energyMeasurment}
                label={'Energimätning'}
                onChange={(e) => answerQuestion(QUESTION_ENERGY_MEASUREMENT_KEY, e.target.value)}
            >
                {Object.keys(ENERGY_MEASUREMENT_OPTIONS).map((energyKey) => {
                    if (disableChoice(ENERGY_MEASUREMENT_OPTIONS[energyKey])) {
                        return (
                            <Tooltip key={energyKey} arrow placement="right" title={toolTipText}>
                                <span>
                                    <MenuItem disabled>{ENERGY_MEASUREMENT_OPTIONS[energyKey]?.label}</MenuItem>
                                </span>
                            </Tooltip>
                        )
                    }
                    else {
                        return (
                            <MenuItem key={energyKey} value={ENERGY_MEASUREMENT_OPTIONS[energyKey]?.value}>{ENERGY_MEASUREMENT_OPTIONS[energyKey]?.label}</MenuItem>
                        )
                    }
                })}
            </Select>
        </FormControl>
    );
}